import { render, staticRenderFns } from "./backup-availability.vue?vue&type=template&id=f393a6aa"
import script from "./backup-availability.vue?vue&type=script&lang=js"
export * from "./backup-availability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports